import {
  blue,
  cyan,
  deepOrange,
  deepPurple,
  green,
  grey,
  indigo,
  orange,
  pink,
  purple,
  yellow,
} from "@mui/material/colors";
import { Theme } from "@mui/material/styles";

export const ProgramAreaLabelMap: { [area: string]: string } = {
  NPDES: "Water",
  RCRA: "Waste",
  AIR: "Air",
  TRI: "TRI",
  Default: "Other",
};

export const ProgramAreaColors: { [area: string]: string } = {
  Water: cyan[400],
  Waste: pink[300],
  Air: deepPurple[200],
  TRI: orange[400],
  // Mid-grey instead of the old near-black "#666", which was invisible on dark
  // tiles. grey[500] is a true neutral that reads on both schemes. For a
  // fully scheme-adaptive value use getProgramAreaColors(theme) below.
  Other: grey[500],
  Chemicals: indigo[400],
  "Multiple Programs": blue[400],
};

/**
 * Scheme-adaptive variant of {@link ProgramAreaColors}. The categorical hues are
 * fine on both light and dark, but the neutral "Other" slice should track the
 * theme so it stays legible. Prefer this in components that have a `theme`.
 */
export function getProgramAreaColors(theme: Theme): { [area: string]: string } {
  return {
    ...ProgramAreaColors,
    Other: theme.palette.text.secondary,
  };
}

/** Helper function to generate quarters for the past 3 years. */
export function generateQuarters(): string[] {
  const quarters = [];
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentQuarter = Math.floor(currentDate.getMonth() / 3) + 1;

  for (let year = currentYear - 3; year <= currentYear; year++) {
    for (let quarter = 1; quarter <= 4; quarter++) {
      quarters.push(`Q${quarter} ${year}`);
      if (year === currentYear && quarter === currentQuarter) break;
    }
  }

  return quarters;
}

export const PriorityChartColors = [
  blue[400],
  purple[300],
  yellow[600],
  pink[200],
  cyan[200],
  deepOrange[300],
  green[300],
  indigo[400],
  orange[300],
  pink[400],
];

export function getPriorityChartColorByIndex(index: number) {
  const remainder = index % PriorityChartColors.length;

  return PriorityChartColors[remainder];
}

export const PriorityChartColorsPurple = [
  indigo[400],
  deepPurple[200],
  indigo[200],
  deepPurple[500],
  deepPurple[100],
  indigo[300],
  indigo[700],
  deepPurple[200],
  deepPurple[400],
  indigo[100],
];
